import { render, staticRenderFns } from "./group-wallet-table.vue?vue&type=template&id=3773b675&scoped=true&"
import script from "./group-wallet-table.vue?vue&type=script&lang=js&"
export * from "./group-wallet-table.vue?vue&type=script&lang=js&"
import style0 from "./group-wallet-table.vue?vue&type=style&index=0&id=3773b675&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3773b675",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSpacer,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3773b675')) {
      api.createRecord('3773b675', component.options)
    } else {
      api.reload('3773b675', component.options)
    }
    module.hot.accept("./group-wallet-table.vue?vue&type=template&id=3773b675&scoped=true&", function () {
      api.rerender('3773b675', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/group-wallet-table/group-wallet-table.vue"
export default component.exports